import { motion } from "framer-motion";
import { Phone, Mail, MapPin, MessageCircle, Instagram, Clock } from "lucide-react";

const ITEMS = [
  {
    icon: MessageCircle,
    label: "WhatsApp",
    value: "+91 73838 99003",
    href: "https://wa.me/917383899003?text=Hi%20Blisson%2C%20I%27d%20like%20help",
    note: "Fastest reply · Mon–Sat 10am–7pm",
  },
  {
    icon: Phone,
    label: "Phone",
    value: "+91 73838 99003",
    href: "tel:+917383899003",
    note: "Call us during business hours",
  },
  {
    icon: Mail,
    label: "Email",
    value: "theblisson@gmail.com",
    href: "mailto:theblisson@gmail.com",
    note: "We reply within 24 hours",
  },
  {
    icon: Instagram,
    label: "Instagram",
    value: "@blisson.in",
    href: "https://instagram.com/blisson.in",
    note: "Behind the scenes & launches",
  },
];

export default function Contact() {
  return (
    <div className="pt-28 md:pt-32 pb-20 min-h-screen bg-white" data-testid="page-contact">
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 md:mb-16"
        >
          <div className="overline mb-3 text-[#C9A961]">We're here for you</div>
          <h1 className="font-serif-display text-4xl md:text-6xl tracking-tighter font-light leading-[1.05]">
            Get in <em className="gold-text not-italic">touch.</em>
          </h1>
          <p className="text-base md:text-lg text-[#5C5C5C] mt-5 max-w-lg mx-auto">
            Whether it's a product question, order help or a salon-partnership enquiry — we're
            one tap away.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12" data-testid="contact-grid">
          {ITEMS.map((it, i) => (
            <motion.a
              key={it.label}
              href={it.href}
              target={it.href.startsWith("http") ? "_blank" : undefined}
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.08 * i, duration: 0.5 }}
              className="border border-black/10 p-6 hover:border-[#C9A961] transition-colors group block"
              data-testid={`contact-${it.label.toLowerCase()}`}
            >
              <it.icon size={22} strokeWidth={1.3} className="text-[#C9A961] mb-3" />
              <div className="overline text-[10px] mb-1">{it.label}</div>
              <div className="font-serif-display text-xl md:text-2xl group-hover:text-[#C9A961] transition-colors">
                {it.value}
              </div>
              <div className="text-xs text-[#5C5C5C] mt-2">{it.note}</div>
            </motion.a>
          ))}
        </div>

        <div className="border-t border-black/10 pt-8 grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-[#3a3a3a]">
          <div className="flex items-start gap-3">
            <MapPin size={18} strokeWidth={1.3} className="text-[#C9A961] mt-1 shrink-0" />
            <div>
              <div className="overline text-[10px] mb-1">Registered Office</div>
              <div className="leading-relaxed">
                Blisson Professional<br />
                Morbi, Gujarat — 363641<br />
                India
              </div>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <Clock size={18} strokeWidth={1.3} className="text-[#C9A961] mt-1 shrink-0" />
            <div>
              <div className="overline text-[10px] mb-1">Business Hours</div>
              <div className="leading-relaxed">
                Mon – Sat · 10:00 am – 7:00 pm IST<br />
                Sunday closed<br />
                <span className="text-[#5C5C5C]">WhatsApp replies even on Sundays</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
